import { Link } from "react-router-dom";

const ShowProducts = ({ works }) => {

  return (
    <div className="flex justify-around">
      <div className="w-full mt-12 justify-around items-center flex-wrap flex-col lg:flex-row flex gap-x-3">
        {works.map((item,index) => {
          return (
            <Link className="mt-8" key={index} to={`/category/${item.id}`}>
              <div className="flex flex-col justify-between w-[100%] lg:w-[100%]">
                <img className="w-full max-w-[330px] 2xl:max-w-[300px] object-contain md:object-cover max-h-[300px] min-h-[280px] md:min-h-[300px]" alt="png" src={item.image}/>
                <div className="mt-3">
                  <p className="text-darkBg dark:text-lightBg font-customFont font-light text-[22px] two-line-truncate max-w-[428px]">{item.name}</p>
                </div>
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
export default ShowProducts;
